import type { SegmentsListFilters } from '@openx/components-segment/types';
import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria';
import { TABLE_PAGE_SIZE } from '../../../config';
import type { DefaultTableCriteria } from '../../../utils/useListCriteria';

export const defaultSegmentsCriteria: DefaultTableCriteria<'segments'> = {
  [CriteriaDimension.FILTERS]: {
    account: '',
    phrase: '',
    provider: '',
    status: '',
    regions: '',
    countries: '',
    reach: null,
    price_cpm: null,
    price_pom: null,
    segment_category: '',
    segment_sub_category: '',
    segment_type: '',
    created_date: '',
    updated_date: '',
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 100,
  },
  [CriteriaDimension.SORT]: {
    column: 'created_date',
    direction: SortDirection.DESC,
    sortableColumns: ['name', 'reach', 'status', 'description', 'provider', 'account', 'created_date', 'updated_date'],
    valuePath: {
      account: ['name'],
      provider: ['name'],
    },
  },
};

export type { SegmentsListFilters };
